import { useId, useRef } from 'react';

var uniqueIdCounter = 0;
var useUniqueId = function useUniqueId() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'id';
  var reactId = typeof useId === 'function' ? useId() : null;
  var idRef = useRef();
  if (!idRef.current) {
    if (reactId) {
      idRef.current = "".concat(prefix, "-").concat(reactId);
    } else {
      uniqueIdCounter += 1;
      idRef.current = "".concat(prefix, "-").concat(uniqueIdCounter);
    }
  }
  return idRef.current;
};
var useUniqueId$1 = useUniqueId;

export { useUniqueId$1 as default };
//# sourceMappingURL=useUniqueId.js.map
